import React from "react";
import styles from "./HangingClosedBoard.module.css";

/** Animated hanging “Closed” sign for storefront preview / cards. */
export default function HangingClosedBoard({
  label = "Closed",
  className = "",
  compact = false,
  hangFromEdge = false,
}) {
  return (
    <div
      className={`${styles.wrap} ${compact ? styles.wrapCompact : ""} ${hangFromEdge ? styles.hangFromEdge : ""} ${className}`.trim()}
      aria-label={label}
      role="status"
    >
      <span className={styles.stringLeft} aria-hidden="true" />
      <span className={styles.stringRight} aria-hidden="true" />
      <div className={styles.board}>
        <span className={styles.nail} aria-hidden="true" />
        <span className={styles.text}>{label}</span>
      </div>
    </div>
  );
}
